// Выход выполняется ОБЫЧНЫМ (не-Inertia) переходом браузера, как вход/регистрация
// (см. SignIn.vue / SignUp.vue). Devise#destroy редиректит на публичный лендинг
// (root_path) — это НЕ Inertia-страница, а полный HTML в лёгком layout. Если бы
// выход шёл через router.delete() (Inertia-визит), клиент получил бы HTML вместо
// Inertia-ответа и показал бы его в dev-модалке поверх затемнённого экрана
// (расписание на фоне). Поэтому собираем и сабмитим форму POST + _method=delete
// с CSRF-токеном — full-page navigation, после которого лендинг рендерится нормально.
export function signOut(): void {
  const form = document.createElement('form')
  form.method = 'post'
  form.action = '/lk/sign_out'

  const method = document.createElement('input')
  method.type = 'hidden'
  method.name = '_method'
  method.value = 'delete'
  form.appendChild(method)

  const token = document.createElement('input')
  token.type = 'hidden'
  token.name = 'authenticity_token'
  token.value = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? ''
  form.appendChild(token)

  document.body.appendChild(form)
  form.submit()
}
